import * as svg from "../../../assets/gift-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const GiftIcon = iconBuilder(svg, "GiftIcon", "0 0 16 16");
